
import * as React from 'react'
import ReactDOM from 'react-dom';
import { Spinner } from 'react-bootstrap'
import _ from 'lodash';
import { css } from 'glamor'
import './styleAutoComplete.css'
import { randomId } from '../../utils';

declare const { defaultValue, value, ...inputAttributes }: React.InputHTMLAttributes<HTMLInputElement>;
type InputAttributes = typeof inputAttributes;


const defaultStyleMenuPortal = { flex: 1, marginTop: 2, marginBottom: 2, width: 0 }
const omitProps = [
  'customInput',
  "dataSource",
  "stopSearching",
  "textValue",
  'editable',
  'renderRow',
  'menuPortal',
  'autoHide',
  'idAddresss',
  // Event listeners
  "searchData",
  "renderItemRow",
  "onPressItem",
  "onChangeText",
  'onChange',
];
const styles = {
  autocomplete: css({
    'position': 'absolute',
    'display': 'inline-block',
    'boxShadow': '0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12)',
    'zIndex': '999',
  }),
  autocompleteItems: css({
    'border': "1px solid #e6e6e6",
    "borderTop": "none",
    "zIndex": 99,
    /*position the autocomplete items to be the same width as the container:*/
    "top": "100%",
    "left": 0,
    "right": 0,
    "whiteSpace": "nowrap",
    "textOverflow": "ellipsis",
    "overflow": "hidden",
    "lineHeight": "30px",
    "fontSize": " 11px",
    '>div': {
      'cursor': 'pointer',
      'backgroundColor': '#fff',
      'borderBottom': '1px solid #e6e6e6',
      'padding': '5px'
    },
  }),
  scroll: css({
    maxHeight: "400px",
    overflowY: "auto",
  })
}

const keyGenerator = () => (
  Math.random().toString(36).substr(2, 10)
);
export type MenuPlacement = 'auto' | 'bottom' | 'top';
export type MenuPosition = 'absolute' | 'fixed';
export type RectType = {
  left: number,
  right: number,
  bottom: number,
  height: number,
  width: number,
};

export type MenuPortalProps = {
  menuPlacement?: MenuPlacement,
  menuPosition?: MenuPosition,
};
const coercePlacement = p => (p === 'auto' ? 'bottom' : p);

type PortalStyleArgs = {
  offset: number,
  position: MenuPosition,
  rect: RectType,
};

export const menuPortalCSS = ({ rect, offset, position }: PortalStyleArgs) => ({
  left: rect.left,
  position: position,
  top: offset,
  width: rect.width,
  zIndex: 1,
});


export function getBoundingClientObj(element: HTMLElement) {
  const rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width,
  };
}

export interface IInputAutoCompleteHookProps extends InputAttributes {

  textValue?: string
  dataSource?: any
  stopSearching?: boolean
  searchData?(search: string): Promise<any | void>
  renderRow?(item: any, index: number): JSX.Element
  onPressItem?(item: any): void
  onChangeText?(text: string): void
  renderRows?(data: Array<any>): JSX.Element
  editable?: boolean
  menuPortal?: MenuPortalProps
  autoHide?: boolean
  customInput?: React.ComponentType<any>
  [key: string]: any;
}



const InputAutoComplete: React.FC<IInputAutoCompleteHookProps> = (props) => {

  const [text, setText] = React.useState("")
  const [value, setValue] = React.useState("")
  const [listViewDisplay, setlistViewDisplay] = React.useState(false)
  const [dataSource, setDataSource] = React.useState([])
  const [maxWidth, setMaxWidth] = React.useState(160)
  const delayedQuery = React.useRef(_.debounce(q => getSearch(q), 1000)).current;
  const [myInput, setMyInput] = React.useState(null)
  // const [placement, setPlacement] = React.useState('top');
  const [textValueDirty, setTextValueDirty] = React.useState("");
  const [isSearching, setIsSearching] = React.useState(false);
  const [styleMenuPortal, setStyleMenuPortal] = React.useState({
    left: 0,
    position: "absolute",
    top: 0,
    width: 0,
    zIndex: 1,
  });


  const controlRef = React.useRef(null)
  const timerRef = React.useRef();
  const inputRef = React.useRef(null)
  React.useEffect(() => {
    if (inputRef && inputRef.current && inputRef.current.offsetWidth) {
      setMaxWidth(inputRef.current.offsetWidth)
    }

  }, [])

  React.useEffect(() => {
    // console.log("props.textValue->InputAutoComplete", props.textValue)
    if (props.textValue != undefined && props.textValue != null) {
      setText(props.textValue)
    }

    if (!_.isEqual(props.textValue, textValueDirty)) {
      fixPosition()

      setTextValueDirty(props.textValue)
    }

  }, [controlRef, props.textValue])


  React.useEffect(() => {

    document.body.addEventListener('mousedown', toggleShowList);
    return () => {

      clearTimeout(timerRef.current);

      document.body.removeEventListener('mousedown', () => {

        clearTimeout(timerRef.current);
      })
    }
  }, [])




  React.useEffect(() => {
    if (props.dataSource) {
      setDataSource(props.dataSource)
    }

  }, [props.dataSource])


  React.useEffect(() => {
    if (props.stopSearching === true) {
      setlistViewDisplay(false)
      setDataSource([])

    }
  }, [props.stopSearching])


  React.useEffect(() => {
    stopSearching();
  }, [props.stopSearching]) // use function 


  const toggleShowList = (event) => {

    if (props.autoHide && controlRef.current && !controlRef.current.contains(event.target)) {

      // useTimeout(() => {
      //   setlistViewDisplay(false)
      // }, 500);

      const id = setTimeout(() => {
        setlistViewDisplay(false)
      }, 500);
      // console.log("timerRef->id", id)
      // @ts-ignore
      timerRef.current = id;
    }
  }



  const fixPosition = () => {
    if (controlRef && controlRef.current) {
      // console.log(controlRef)
      const placementState = coercePlacement(props.menuPortal.menuPlacement);
      // console.log("controlRef", controlRef)

      const rect = getBoundingClientObj(controlRef.current)
      const isFixed = props.menuPortal.menuPosition === 'fixed';
      const scrollDistance = isFixed ? 0 : window.pageYOffset;
      // console.log("isFixed", isFixed)
      // console.log("scrollDistance", scrollDistance)
      const offset = rect[placementState] + scrollDistance;
      const position = props.menuPortal && props.menuPortal.menuPosition ? props.menuPortal.menuPosition : 'absolute'
      const state: PortalStyleArgs = { rect, offset, position };
      const style = menuPortalCSS(state)
      setStyleMenuPortal(style)
      // console.log("position", position)
      // console.log("rect", rect)
      // console.log("offset", offset)
      // console.log("style", style)
    }

  }

  /**
   * after selected item can use this function hidden list 
   */


  const stopSearching = () => {
    setlistViewDisplay(false)
    setDataSource([])
  }
  /*
    *  fetch api search autocompelte 
    * 
    */
  const getSearch = async (search) => {
    setIsSearching(true)
    try {
      props.searchData(search).then((data) => {
        console.log("getSearch", data)

        setIsSearching(false)
        if (_.isArray(data)) {
          setDataSource(data)
        }
      });
    } catch (error) {
      setIsSearching(false)
      console.warn("error" + error);
    }

  }



  const renderRows = (dataSource) => {
    // console.log("dataSource", dataSource)
    if (dataSource) {
      return Object.keys(dataSource).map((key, index) => {
        return renderRow(dataSource[key], index)
      })
    }
  }

  const renderRow = (rowData, index) => {
    if (props.renderRow) {
      return (
        <div key={index + "" + keyGenerator()} >
          {props.renderRow(rowData, index)}
        </div>
      )
    }

  }

  const _onPress = (rowData) => {
    setlistViewDisplay(false)
    if (props.onPressItem) {
      props.onPressItem(rowData);
    }
  }

  const renderResults = () => {
    if (!isSearching && dataSource.length <= 0) {
      return null;
    }

    if (props.textValue !== '' && listViewDisplay == true) {
      if (props.renderRows) {
        return props.renderRows(dataSource)
      }
      return (
        // <div style={{ position: 'relative', minHeight: 400 }}>


        <div  {...styles.scroll} className={`${styles.autocomplete} ${css(styleMenuPortal)}`} style={{ flex: 1, marginTop: 2, marginBottom: 2 }}>
          <div className={`${styles.autocompleteItems}`} style={{}}>
            {renderRows(dataSource)}
          </div>
        </div>
        // </div>
      )
    }

    return null;
  }




  const setRef = (ref) => {
    setMyInput(ref)
  }

  const onChange = (event) => {
    onChangeValue(event.target.value)

    if (props.onChange) {
      props.onChange(event)
    }
  }


  const onChangeValue = (value) => {
    if (inputRef && inputRef.current && inputRef.current.getBoundingClientRect) {
      setMaxWidth(inputRef.current.getBoundingClientRect().width)
    }

    setText(value)
    if (!props.disabled) {
      setlistViewDisplay(true)
      if (value.length > 1) {
        delayedQuery(value);
      }
    }

    if (props.onChangeText) {
      props.onChangeText(value);
    }

  }



  const renderInput = () => {
    if (props.customInput) {
      const CustomInput = props.customInput;
      return <CustomInput
        {..._.omit(props, omitProps)}
        className={`${props.className}  input-autocomplete`}
        value={`${props.textValue}`}
        style={props.style}
        ref={setRef}
        onChange={onChange}
        placeholder={props.placeholder} />;
    } else {
      return (
        <input
          {..._.omit(props, omitProps)}
          className={`${props.className} form-control input-autocomplete`}
          value={`${props.textValue}`}
          style={props.style}
          ref={setRef}
          onChange={onChange}
          placeholder={props.placeholder}
        />
      )
    }
  }

  return (
    <>
      {renderInput()}

      <div ref={controlRef}>
        {/* {isSearching && <div style={{ position: "absolute", top: "10%", right: 1 }}>
          <Spinner size="sm" variant="success" animation="border" />
        </div>} */}

        {ReactDOM.createPortal(renderResults(), document.querySelector('body'))}
      </div>

      {/* {renderResults()} */}

    </>
  )

}

InputAutoComplete.defaultProps = {
  style: {},
  editable: true,
  menuPortal: {
    menuPlacement: 'bottom',
    menuPosition: 'absolute'
  },
  autoHide: true,
}
export default InputAutoComplete;
export { InputAutoComplete };
